import {
  ActivityIndicator,
  Dimensions,
  FlatList,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Switch,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import MoneyIcon from "../../icons/MoneyIcon";
import PullsIcon from "../../icons/PullsIcon";
import ViewMoreIcon from "../../icons/ViewMoreIcon";
import useAuth from "../../hooks/useAuth";
import { useBalance } from "../../context/AppContext";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import SpendFromTable from "./SpendFromTable";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import TableTransactionHistoryScreen from "./TableTransactionHistoryScreen";
import ADoingScreen from "../aDoingScreen/ADoingScreen";
import UsernamePasswordTransactCode from "../settings/UsernamePasswordTransactCode";
import TopUpSmallAmounts from "./TopUpSmallAmounts";
import NoticeAlertComp from "../../alertComp/NoticeAlertComp";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

const BodyMyTables = ({
  isLoadingTables,
  tableDataList,
  setIsOpen,
  tableName,
  setTableName,
  isLoading11,
  setShowAddFriendsScreen2,
  handleAddFriendsToTable,
  tableInviteVisible,
  joinedTablesVisible,
  //setJoinedTableVisible,
  tableInvites,
  joinedTables,
  contributions,
  setJoinedTableID,
  handleOpenTableCategories,
  handleOpenTableCategories2,
  setShowJoined_A_TableListScreen,
}) => {
  // const { contributions } = useBalance();

  const [selected, setSelectedTable] = useState("All");
  const [isInvitesSelected, setIsInvitesSelected] = useState(true);
  const [isMyTablesSelected, setIsMyTableSelected] = useState(true);
  const [isJoinedTablesSelected, setIsJoinedTableSelected] = useState(true);
  const [isEditTableSelected, setEditTableSelected] = useState(false);

  const [showTableTransactions, setShowTableTransactions] = useState(false);

  const [showUsernamePasswordTransactCode, setShowUsernamePasswordTransactCode] = useState(false);
  const [passwordIsCorrect, setPasswordIsCorrect] = useState(false);

  const [isMyTableVisible, setIsMyTableVisible] = useState(false);

  const [tableToUseID, setTableToUseID] = useState();
  const [useCaption, setUseCaption] = useState();
  const [useContributionAmount, setUseContributionAmount] = useState();
  const [contributors, setContributors] = useState();
  const [usePull, setUsePull] = useState();
  const [tableDataForReciept, setTableDataForReciept] = useState();
  const [tableDataToUse, setTableDataToUse] = useState();

  const [showSpendFromTable, setShowSpendFromTable] = useState(false);
  const [showTransferFromTable, setShowTransferFromTable] = useState(false);
  const [showPurchaseFromTable, setShowPurchaseFromTable] = useState(false);
  const [showConfirmTransfer, setShowConfirmTransfer] = useState(false);
  const [showPaymentReceipt, setShowPaymentReceipt] = useState(false);
  const [showViewReciepts, setShowViewReciepts] = useState(false);

  const [showTheDoingsAmount, setShowTheDoingsAmount] = useState(false);
  const [showA_PartyHeatScreen, setShowA_PartyHeatScreen] = useState(false);
  const [showPartyHeatComp, setShowPartyHeatComp] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);

  const [showADoingsScreen, setShowADoingsScreen] = useState(false);
  const [selectedTableData, setSelectedTableData] = useState(null);

  const [showSmallTopUps, setShowSmallTopUp] = useState(false);
  const [smallTopUpTableData, setSmallTopUpTableData] = useState(null);

  const [noticeMessage, setNoticeMessage] = useState("");
  const [showNoticeAlert, setshowNoticeAlert] = useState(false);
  const [theSelectedTable, setTheSelectedTable] = useState(null);

  const [editingId, setEditingId] = useState(null);
  const [historyID, setHistoryID] = useState(null);
  const [newCaption, setNewCaption] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [isNoticeLoading, setIsNoticeLoading] = useState(false);

  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [allowComments, setAllowComments] = useState(true);

  const { isReverified, updateInteraction, reverifyUser, isBlockedAccess } = useAuth();

  useEffect(() => {
    if (passwordIsCorrect) {
      reverifyUser();
      // optionally reset to false if you don’t want it to run multiple times
      setPasswordIsCorrect(false);
    }
  }, [passwordIsCorrect, reverifyUser]);

  useEffect(() => {
    if (!isReverified) {
      //console.log('Timer is up, isReverified is now false.');
    }
  }, [isReverified]);

  const tableList = [
    { table: "All" },
    { table: "My Tables" },
    { table: "Joined Tables" },
    { table: "Reservations" },
    { table: "Edit Table" },
  ];

  const { sub } = useAuth();

  const axiosPrivate = useAxiosPrivate();

  const toggleAllowComments = () => {
    setAllowComments((prev) => !prev);
  };

  useEffect(() => {
    // setIsInvitesSelected(true)
    setIsJoinedTableSelected(true);
    setIsMyTableSelected(true);

    // if (joinedTables.length > 0) {
    //   setJoinedTableVisible(true)
    // } else {
    //   setJoinedTableVisible(false)
    // }

    if (tableDataList.length > 0) {
      setIsMyTableVisible(true);
    } else {
      setIsMyTableVisible(false);
    }
    //console.log('tableDATAList:', tableDataList)
    //console.log('Contributors:', contributors)
    //console.log('joinedTables555', joinedTables)
    //console.log('joinedTablesVisible', joinedTablesVisible)
  }, [tableDataList, contributors, joinedTables, joinedTablesVisible]);

  // const handleTablePress = (tableName) => {
  //   setIsOpen(true)
  //   //console.log('name:', tableName)
  //   setTableName(tableName)
  // }

  // const handleSpendPattern = (pattern) => {
  //   setActivePattern(pattern)
  // }

  const hideAllPayScreens = () => {
    setShowSpendFromTable(false);
    setShowPurchaseFromTable(false);
    setShowTheDoingsAmount(false);
    setShowPartyHeatComp(false);
    setShowA_PartyHeatScreen(false);
    setSuccessMessage(false);
    setShowTransferFromTable(false);
    setShowConfirmTransfer(false);
    setShowPaymentReceipt(false);
  };

  const handleViewTableProfile = (table) => {
    setSelectedTableData(table);
    setShowADoingsScreen(true);
  };

  const handleSpendFromThisTable = (
    tableData,
    tableID,
    caption,
    contributors,
    pull,
    contribution,
  ) => {
    setShowSpendFromTable(true);
    setTableToUseID(tableID);
    setUseCaption(caption);
    setUseContributionAmount(contribution);
    setContributors(contributors);
    setUsePull(pull);
    setTableDataToUse(tableData);
  };

  const handleJoinedPress = (tableID) => {
    setShowJoined_A_TableListScreen(true);
    //console.log('tableID', tableID)
    setJoinedTableID(tableID);
  };

  const handleSelectedTable = (selectedTables) => {
    setSelectedTable(selectedTables);
    if (selectedTables === "All") {
      // setIsInvitesSelected(true)
      setIsJoinedTableSelected(true);
      setIsMyTableSelected(true);
      setEditTableSelected(false);
    } else if (selectedTables === "My Tables") {
      // setIsInvitesSelected(false)
      setIsJoinedTableSelected(false);
      setIsMyTableSelected(true);
      setEditTableSelected(false);
    } else if (selectedTables === "Joined Tables") {
      // setIsInvitesSelected(false)
      setIsJoinedTableSelected(true);
      setIsMyTableSelected(false);
      setEditTableSelected(false);
    } else if (selectedTables === "Reservations") {
      // setIsInvitesSelected(false)
      setIsJoinedTableSelected(false);
      setIsMyTableSelected(false);
      setEditTableSelected(false);
    } else if (selectedTables === "Edit Table") {
      setIsJoinedTableSelected(false);
      setIsMyTableSelected(false);
      setEditTableSelected(true);
    }
  };

  const onUpdateCaption = async (tableID, newCaption) => {
    setIsLoading(tableID);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.patch("/editTable/editTable", { tableID, newCaption });

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('newlyEdited Data:', response.data);

        // setCreditTransactData(response.data)

        Toast.show({
          type: "success",
          text1: "Success",
          text2: response.data.message,
        });

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
        Toast.show({
          type: "error",
          text1: "Error",
          text2: "Unexpected response",
        });
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);

        Toast.show({
          type: "error",
          text1: "Error",
          text2: error.response.data?.message || "Something went wrong!",
        });
      } else if (error.request) {
        //console.error('No response received:', error.request);

        Toast.show({
          type: "error",
          text1: "Network Error",
          text2: "No response from the server. Check your internet connection.",
        });
      } else {
        //console.error('Error setting up the request:', error.message);

        Toast.show({
          type: "error",
          text1: "Error",
          text2: error.message || "An unexpected error occurred.",
        });
      }
    } finally {
      setIsLoading(null);
    }
  };

  const handleEditPress = (tableData) => {
    setEditingId(tableData._id);
    setNewCaption(tableData.tableCaption);
  };

  const handleSave = (tableData) => {
    onUpdateCaption(tableData._id, newCaption); // Call the function to update caption in parent component or backend
    setEditingId(null);
  };

  const handleReciepts = (tableData) => {
    setShowViewReciepts(true);
    setTableDataForReciept(tableData);
  };
  const handleViewTableHistory = (tableID) => {
    setHistoryID(tableID);
    setShowTableTransactions(true);
  };

  const handleOpenTopUp = (topUpTable) => {
    setSmallTopUpTableData(topUpTable);
    setShowSmallTopUp(true);
  };

  const setContributorsAndTicketPaid = (tableData) => {
    const contributedUserIDs = tableData.contributions.map((contribution) =>
      contribution.userID.toString(),
    );

    // Extract user IDs from paidForTickets
    const paidUserIDs = tableData?.pull?.paidForTickets?.map((ticket) => ticket?.userID?._id);

    // Find contributors who haven't paid for tickets
    const unpaidContributors = contributedUserIDs.filter((userID) => !paidUserIDs.includes(userID));
  };

  const handleShowNoticeAlert = (tableSelected) => {
    setTheSelectedTable(tableSelected._id);
    setNoticeMessage("Move all little funds to credit");
    setshowNoticeAlert(true);
  };

  const handleMoveTableRemainingFundToCredit = async () => {
    try {
      setIsNoticeLoading(true);
      const response = await axiosPrivate.post("/addSmallFundsToCredit/addSmallFundsToCredit", {
        theSelectedTable,
      });

      if (response.status === 200 || response.status === 201) {
        setshowNoticeAlert(false);
        setSuccessMessage(response.data.message);
        setIsSuccessCompVisible(true);
      } else {
        setshowNoticeAlert(false);
        setErrorMessage("Unexpected response");
        setIsErrorCompVisible(true);
      }
    } catch (error) {
      //console.log('Errors', error)
      if (error.response) {
        // //console.error('Error response from server:', error.response.data);
        setshowNoticeAlert(false);
        const errorMessages =
          error.response.data?.error || error.response.data?.message || "Something went wrong";
        setErrorMessage(errorMessages);
        setIsErrorCompVisible(true);
      } else if (error.request) {
        // //console.error('No response received:', error.request);
        setshowNoticeAlert(false);
        setErrorMessage("No response Recieved check your internet");
        setIsErrorCompVisible(true);
      } else {
        // //console.error('Error setting up the request:', error.message);
        setshowNoticeAlert(false);
        setErrorMessage(error.message || "Unexpected error occurred");
        setIsErrorCompVisible(true);
      }
    } finally {
      setIsNoticeLoading(false);
    }
  };

  const getReservationOrTicketAmount = (tableData) => {
    //console.log('WE ARE OUTSIDE')
    if (!tableData || !tableData.pull) return null;
    const reservationData = tableData.pull.paidForReservations.find(
      (res) => res.table === tableData._id,
    );

    //console.log('tableDataX', tableData)

    // const contributedUserIDs = tableData.contributions.map(contribution => contribution.userID.toString());
    // //console.log('contributedUserIDs', contributedUserIDs)

    // // Extract user IDs from paidForTickets
    // const paidUserIDs = tableData.pull.paidForTickets.map(ticket => ticket.userID.toString());
    // //console.log('paidUserIDs', paidUserIDs)

    // // Find contributors who haven't paid for tickets
    // const unpaidContributors = contributedUserIDs.filter(userID => !paidUserIDs.includes(userID));

    // //console.log("Unpaid Contributors:", unpaidContributors);

    if (reservationData) {
      return (
        <>
          {/* <Text style={{ fontSize: 15, fontFamily: 'Sen-Regular', color: Colours.PRIMARY }}>
            Reservation Amount:
          </Text> */}
          <Text style={styles.pullAmount}>₦{reservationData.amount.toLocaleString()}</Text>
        </>
      );
    } else {
      return (
        <Text style={styles.pullAmount}>
          ₦{" "}
          {tableData.pull.ticketPrice &&
          tableData.pull.paidForTickets &&
          tableData.pull.paidForTickets.length > 0 &&
          tableData.contributions.length > 0
            ? (() => {
                // Extract contributed user IDs
                const contributedUserIDs = tableData.contributions.map((contribution) =>
                  contribution.userID.toString(),
                );

                // Extract paid user IDs from paidForTickets
                const paidUserIDs =
                  tableData?.pull?.paidForTickets?.map((ticket) =>
                    ticket?.userID?._id?.toString(),
                  ) || [];

                // Find contributors who have paid for tickets
                const paidContributors = contributedUserIDs.filter((userID) =>
                  paidUserIDs.includes(userID),
                );

                // Calculate total ticket price for paid contributors
                return (tableData.pull.ticketPrice * paidContributors.length).toLocaleString();
              })()
            : 0}
        </Text>
      );
    }
  };

  if (isLoading11) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <View style={styles.myTablesContainer}>
      <View style={styles.TableValueContainer}>
        <Text style={styles.label}>My Table Balance</Text>
        {/* {isLoadingTables ? ( */}
        {/* <ActivityIndicator size="small" color={Colours.PRIMARY} /> */}
        {/* ) : ( */}

        <Text style={styles.balance}>
          {isReverified && !isBlockedAccess ? contributions?.toLocaleString() : "**** "}
        </Text>
        {isReverified ? (
          ""
        ) : (
          <TouchableOpacity
            onPress={() => {
              setShowUsernamePasswordTransactCode(true);
            }}
          >
            <ViewMoreIcon height={40} width={40} color={Colours.PRIMARY} />
          </TouchableOpacity>
        )}
        {/* )} */}

        <View style={{ height: 55, marginTop: 15 }}>
          <FlatList
            data={tableList}
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item, index }) => (
              <TouchableOpacity
                style={{ marginRight: 10 }}
                onPress={() => {
                  updateInteraction();
                  handleSelectedTable(item.table);
                }}
              >
                <Text
                  style={[selected == item.table ? styles.selectedTable : styles.unselectedTable]}
                >
                  {item.table}
                </Text>
              </TouchableOpacity>
            )}
          />
        </View>
      </View>

      {/**There was a Table Invite code here  "tableInviteVisible and tableInvites were used"*/}

      {!isBlockedAccess && (
        <>
          {isMyTablesSelected && (
            <View>
              {isLoadingTables ? (
                <ActivityIndicator size="small" color={Colours.PRIMARY} />
              ) : (
                isMyTableVisible && (
                  <View style={styles.existingTablesContainer}>
                    <View style={styles.headerStyle}>
                      <Text style={styles.sectionTitle}>My Tables </Text>
                    </View>
                    <FlatList
                      keyExtractor={(item) => item._id}
                      data={tableDataList}
                      scrollEnabled={false}
                      renderItem={({ item: tableData }) => (
                        <View>
                          <TouchableOpacity
                            style={styles.oneTableContainer}
                            //should have outrightly used "tableData" instead of its individual object components
                            onPress={() => {
                              if (!isReverified) {
                                setShowUsernamePasswordTransactCode(true);
                              } else {
                                updateInteraction();
                                handleSpendFromThisTable(
                                  tableData,
                                  tableData._id,
                                  tableData.tableCaption,
                                  tableData.contributions,
                                  tableData.pull,
                                  tableData.totalContributionsAmount.toLocaleString(),
                                );
                              }
                            }}
                          >
                            <View style={styles.tableNameAmountContainer}>
                              <View style={styles.tableCaption_TopUp}>
                                <Text style={styles.tableCaption}>
                                  {tableData.tableCaption}
                                  <Text
                                    style={{
                                      color: Colours.PRIMARY,
                                      fontSize: 11,
                                      fontFamily: "Sen-Bold",
                                    }}
                                  >
                                    {"  > TAP TO SPEND"}
                                  </Text>
                                </Text>

                                {/*Removed Top Up for now*/}

                                {/* Show "Move" only when totalContributionsAmount <= 500 */}
                                {tableData.totalContributionsAmount <= 500 && (
                                  <TouchableOpacity
                                    style={styles.topUpText}
                                    onPress={() => {
                                      if (!isReverified) {
                                        setShowUsernamePasswordTransactCode(true);
                                      } else {
                                        updateInteraction();
                                        handleShowNoticeAlert(tableData);
                                      }
                                    }}
                                  >
                                    <Text style={styles.topUpButtonText}>Move</Text>
                                  </TouchableOpacity>
                                )}
                              </View>
                              <View style={styles.tableAmountContainer}>
                                <MoneyIcon
                                  color={Colours.PRIMARY_LIGHT}
                                  height={dynamicSize(30)}
                                  width={dynamicSize(30)}
                                />
                                <Text style={styles.moneyText}>Money on the Table:</Text>
                                <Text style={styles.moneyAmount}>
                                  {tableData.totalContributionsAmount.toLocaleString()}
                                </Text>
                              </View>

                              {tableData ? (
                                <View style={{ flexDirection: "column", marginVertical: 10 }}>
                                  {/* Pull Details */}
                                  {tableData.pull ? (
                                    <>
                                      <TouchableOpacity
                                        style={styles.doingsAmountContainer}
                                        onPress={() => handleReciepts(tableData)}
                                      >
                                        <View style={styles.doingsAmountSubContainer}>
                                          <MoneyIcon
                                            color={Colours.PRIMARY_LIGHT}
                                            height={dynamicSize(30)}
                                            width={dynamicSize(30)}
                                          />
                                          <Text style={styles.pullCaptionText}>
                                            {tableData.pull.pullCaption}:
                                          </Text>
                                          {tableData.pull.paidForReservations &&
                                          tableData.pull.paidForReservations.length > 0 ? (
                                            getReservationOrTicketAmount(tableData)
                                          ) : (
                                            // Show ticket details if no reservation was made
                                            <Text style={styles.pullAmount}>
                                              {setContributorsAndTicketPaid(tableData)}₦{" "}
                                              {tableData.pull.ticketPrice &&
                                              tableData.pull.paidForTickets &&
                                              tableData.pull.paidForTickets.length > 0 &&
                                              tableData.contributions.length > 0
                                                ? (() => {
                                                    // Extract contributed user IDs
                                                    const contributedUserIDs =
                                                      tableData.contributions.map((contribution) =>
                                                        contribution.userID.toString(),
                                                      );

                                                    // Extract paid user IDs from paidForTickets
                                                    const paidUserIDs =
                                                      tableData?.pull?.paidForTickets?.map(
                                                        (ticket) => ticket?.userID?._id?.toString(),
                                                      ) || [];

                                                    // Find contributors who have paid for tickets
                                                    const paidContributors =
                                                      contributedUserIDs.filter((userID) =>
                                                        paidUserIDs.includes(userID),
                                                      );

                                                    // Calculate total ticket price for paid contributors
                                                    return (
                                                      tableData.pull.ticketPrice *
                                                      paidContributors.length
                                                    ).toLocaleString();
                                                  })()
                                                : 0}
                                            </Text>
                                          )}
                                        </View>
                                      </TouchableOpacity>
                                    </>
                                  ) : (
                                    <Text
                                      style={{
                                        fontSize: 14,
                                        fontFamily: "Sen-Regular",
                                        color: Colours.LIGHTGRAY,
                                      }}
                                    >
                                      No Pull Data Available
                                    </Text>
                                  )}
                                </View>
                              ) : (
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontFamily: "Sen-Regular",
                                    color: Colours.LIGHTGRAY,
                                  }}
                                >
                                  No Table Data Available
                                </Text>
                              )}

                              {/* <View style={styles.toggleContainer}>
                        <Text style={styles.toggleLabel}>Allow Comments</Text>
                        <Switch
                          value={allowComments}
                          onValueChange={toggleAllowComments}
                          thumbColor={allowComments ? Colours.PRIMARY : Colours.LIGHTGRAY}
                          trackColor={{ false: '#ccc', true: Colours.PRIMARY + '55' }}
                        />
                      </View> */}

                              <View style={styles.tableJoined}>
                                <TouchableOpacity
                                  style={styles.joinedView}
                                  onPress={() => {
                                    updateInteraction();
                                    handleJoinedPress(tableData._id);
                                  }}
                                >
                                  <Text style={styles.joinedText}>
                                    {tableData.contributionsCount} FRIENDS
                                  </Text>
                                  <ViewMoreIcon color={Colours.MIDGRAY} />
                                </TouchableOpacity>
                                <TouchableOpacity
                                  onPress={() => {
                                    updateInteraction();
                                    handleViewTableHistory(tableData._id);
                                  }}
                                >
                                  <MoneyIcon
                                    color={Colours.MIDGRAY}
                                    height={dynamicSize(30)}
                                    width={dynamicSize(30)}
                                  />
                                </TouchableOpacity>

                                <TouchableOpacity
                                  style={styles.addFriendsButton}
                                  onPress={() => {
                                    updateInteraction();
                                    handleAddFriendsToTable(tableData);
                                  }}
                                >
                                  <Text style={styles.addFriendsText}>Tag Friends</Text>
                                  {/* <Text style={styles.addFriendsText}>Add Friends</Text> */}
                                </TouchableOpacity>
                              </View>
                            </View>
                            <TouchableOpacity
                              style={styles.tableProfileView}
                              onPress={() => {
                                updateInteraction();
                                handleViewTableProfile(tableData);
                              }}
                            >
                              <Text style={styles.tableProfileViewTxt}>View Table Profile</Text>
                            </TouchableOpacity>
                          </TouchableOpacity>
                          <View style={styles.separator} />
                        </View>
                      )}
                      inverted={true}
                    />
                  </View>
                )
              )}
            </View>
          )}

          {isJoinedTablesSelected && (
            <View>
              {joinedTablesVisible && (
                <View style={styles.invitesTablesContainer}>
                  <View style={styles.headerStyle}>
                    <Text style={styles.sectionTitle}>Tables you joined</Text>
                  </View>
                  <FlatList
                    keyExtractor={(item) => item._id}
                    data={joinedTables}
                    scrollEnabled={false}
                    renderItem={({ item: tableData }) => (
                      <View>
                        <View style={styles.oneTableContainer}>
                          <View style={styles.tableNameAmountContainer}>
                            <View style={styles.tableCaption_TopUp}>
                              <Text style={styles.tableCaption}>{tableData.tableCaption}</Text>

                              {/*Removed Top Up for now*/}

                              {/* <TouchableOpacity style={styles.topUpText}
                        onPress={() => {
                          updateInteraction()
                          handleOpenTableCategories2(tableData._id)
                        }}
                      >
                        <Text style={styles.topUpButtonText}>TopUp</Text>
                      </TouchableOpacity> */}
                            </View>
                            <View style={styles.tableAmountContainer}>
                              <MoneyIcon
                                color={Colours.PRIMARY_LIGHT}
                                height={dynamicSize(30)}
                                width={dynamicSize(30)}
                              />
                              <Text style={styles.moneyText}>Money on the Table:</Text>
                              <Text style={styles.moneyAmount}>
                                {tableData.totalContributionsAmount.toLocaleString()}
                              </Text>
                            </View>

                            {tableData ? (
                              <View style={{ flexDirection: "column", marginVertical: 10 }}>
                                {/* Pull Details */}
                                {tableData.pull ? (
                                  <>
                                    <TouchableOpacity
                                      style={styles.doingsAmountContainer}
                                      onPress={() => handleReciepts(tableData)}
                                    >
                                      <View style={styles.doingsAmountSubContainer}>
                                        <MoneyIcon
                                          color={Colours.PRIMARY_LIGHT}
                                          height={dynamicSize(30)}
                                          width={dynamicSize(30)}
                                        />
                                        <Text style={styles.pullCaptionText}>
                                          {tableData.pull.pullCaption}:
                                        </Text>
                                        {tableData.pull.paidForReservations &&
                                        tableData.pull.paidForReservations.length > 0 ? (
                                          getReservationOrTicketAmount(tableData)
                                        ) : (
                                          // Show ticket details if no reservation was made
                                          <Text style={styles.pullAmount}>
                                            ₦{" "}
                                            {tableData.pull.ticketPrice &&
                                            tableData.pull.paidForTickets &&
                                            tableData.pull.paidForTickets.length > 0 &&
                                            tableData.contributions.length > 0
                                              ? (() => {
                                                  // Extract contributed user IDs
                                                  const contributedUserIDs =
                                                    tableData.contributions.map((contribution) =>
                                                      contribution.userID.toString(),
                                                    );

                                                  // Extract paid user IDs from paidForTickets
                                                  const paidUserIDs =
                                                    tableData?.pull?.paidForTickets?.map((ticket) =>
                                                      ticket?.userID?._id?.toString(),
                                                    ) || [];

                                                  // Find contributors who have paid for tickets
                                                  const paidContributors =
                                                    contributedUserIDs.filter((userID) =>
                                                      paidUserIDs.includes(userID),
                                                    );

                                                  // Calculate total ticket price for paid contributors
                                                  return (
                                                    tableData.pull.ticketPrice *
                                                    paidContributors.length
                                                  ).toLocaleString();
                                                })()
                                              : 0}
                                          </Text>
                                        )}
                                      </View>
                                    </TouchableOpacity>
                                  </>
                                ) : (
                                  <Text
                                    style={{
                                      fontSize: 14,
                                      fontFamily: "Sen-Regular",
                                      color: Colours.LIGHTGRAY,
                                    }}
                                  >
                                    No Pull Data Available
                                  </Text>
                                )}
                              </View>
                            ) : (
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontFamily: "Sen-Regular",
                                  color: Colours.LIGHTGRAY,
                                }}
                              >
                                No Table Data Available
                              </Text>
                            )}
                            <View style={styles.tableJoined}>
                              <TouchableOpacity
                                style={styles.joinedView}
                                onPress={() => {
                                  updateInteraction();
                                  handleJoinedPress(tableData._id);
                                }}
                              >
                                {/* <Text style={styles.joinedText}>{tableData.contributions.length} JOINED</Text> */}
                                <Text style={styles.joinedText}>
                                  {tableData.contributions.length} FRIENDS
                                </Text>
                                <ViewMoreIcon color={Colours.MIDGRAY} />
                              </TouchableOpacity>

                              <TouchableOpacity
                                onPress={() => {
                                  updateInteraction();
                                  handleViewTableHistory(tableData._id);
                                }}
                              >
                                <MoneyIcon
                                  color={Colours.MIDGRAY}
                                  height={dynamicSize(30)}
                                  width={dynamicSize(30)}
                                />
                              </TouchableOpacity>
                            </View>
                          </View>
                          <TouchableOpacity
                            style={styles.tableProfileView}
                            onPress={() => {
                              updateInteraction();
                              handleViewTableProfile(tableData);
                            }}
                          >
                            <Text style={styles.tableProfileViewTxt}>View Table Profile</Text>
                          </TouchableOpacity>
                        </View>
                        <View style={styles.separator} />
                      </View>
                    )}
                    inverted={true}
                  />
                </View>
              )}
            </View>
          )}

          {isEditTableSelected && (
            <View style={styles.editables}>
              <FlatList
                keyExtractor={(item) => item._id}
                data={tableDataList.slice().reverse()}
                scrollEnabled={false}
                renderItem={({ item: tableData }) => (
                  <TouchableOpacity
                    style={styles.tablesForEdit}
                    onPress={() => {
                      updateInteraction();
                      handleEditPress(tableData);
                    }}
                  >
                    {editingId === tableData._id ? (
                      <TextInput
                        style={styles.editableTextBox}
                        value={newCaption}
                        onChangeText={setNewCaption}
                        autoFocus
                        onBlur={() => {
                          updateInteraction();
                          handleSave(tableData);
                        }}
                      />
                    ) : (
                      <Text
                        style={{ fontSize: 16, color: Colours.DARKGRAY, fontFamily: "Sen-Regular" }}
                      >
                        {tableData?.tableCaption}

                        {isLoading === tableData._id ? (
                          <ActivityIndicator size="small" color={Colours.PRIMARY} />
                        ) : (
                          <Text
                            style={{ color: Colours.PRIMARY, fontSize: 11, fontFamily: "Sen-Bold" }}
                          >
                            {"  > EDIT"}
                          </Text>
                        )}
                      </Text>
                    )}
                  </TouchableOpacity>
                )}
              />
            </View>
          )}
        </>
      )}

      <Modal
        animationType="slide"
        visible={showSpendFromTable}
        onRequestClose={() => setShowSpendFromTable(false)}
      >
        <TopHeaderComponent
          headerText={"Spend From Table"}
          hideScreen={() => setShowSpendFromTable(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            <SpendFromTable
              hideScreen={() => setShowSpendFromTable(false)}
              useCaption={useCaption}
              tableToUseID={tableToUseID}
              contributors={contributors}
              usePull={usePull}
              useContributionAmount={useContributionAmount}
              tableDataToUse={tableDataToUse}
              showTransferFromTable={showTransferFromTable}
              setShowTransferFromTable={setShowTransferFromTable}
              showPurchaseFromTable={showPurchaseFromTable}
              setShowPurchaseFromTable={setShowPurchaseFromTable}
              showConfirmTransfer={showConfirmTransfer}
              setShowConfirmTransfer={setShowConfirmTransfer}
              showPaymentReceipt={showPaymentReceipt}
              setShowPaymentReceipt={setShowPaymentReceipt}
              showTheDoingsAmount={showTheDoingsAmount}
              setShowTheDoingsAmount={setShowTheDoingsAmount}
              showA_PartyHeatScreen={showA_PartyHeatScreen}
              setShowA_PartyHeatScreen={setShowA_PartyHeatScreen}
              showPartyHeatComp={showPartyHeatComp}
              setShowPartyHeatComp={setShowPartyHeatComp}
              successMessage={successMessage}
              setSuccessMessage={setSuccessMessage}
              hideAllPayScreens={hideAllPayScreens}
            />
          </View>
        </ScrollView>
      </Modal>

      <Modal
        visible={showTableTransactions}
        animationType="slide"
        onRequestClose={() => setShowTableTransactions(false)}
      >
        <TopHeaderComponent
          headerText={"Table Transaction History"}
          hideScreen={() => setShowTableTransactions(false)}
        />
        <ScrollView
          style={styles.componentStyle}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <TableTransactionHistoryScreen tableID={historyID} />
        </ScrollView>
      </Modal>

      <Modal
        animationType="slide"
        visible={showADoingsScreen}
        onRequestClose={() => setShowADoingsScreen(false)}
      >
        <TopHeaderComponent headerText={"Table"} hideScreen={() => setShowADoingsScreen(false)} />
        <View style={{ backgroundColor: Colours.LIGHTEST }}>
          <ADoingScreen selectedTable={selectedTableData} fromTableProfileView={true} />
        </View>
      </Modal>

      <Modal
        visible={showUsernamePasswordTransactCode}
        //  transparent={true}
        animationType="fade"
        onRequestClose={() => setShowUsernamePasswordTransactCode(false)}
      >
        <UsernamePasswordTransactCode
          hideModal={() => setShowUsernamePasswordTransactCode(false)}
          setPasswordIsCorrect={setPasswordIsCorrect}
        />
      </Modal>
      {/* 
      <Modal
        visible={showSmallTopUps}
        //  transparent={true}
        animationType="fade"
        onRequestClose={() => setShowSmallTopUp(false)}
      >
        <TopHeaderComponent headerText={"Top-Up"} hideScreen={() => setShowSmallTopUp(false)} />

        <ScrollView
          contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}>

          <View style={styles.componentStyle}>
            <TopUpSmallAmounts
              hideModal={() => setShowSmallTopUp(false)}
              tableDataToUse={smallTopUpTableData}
            />
          </View>
        </ScrollView>
      </Modal> */}

      <Modal visible={isErrorCompVisible} animationType="fade" transparent={true}>
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            setIsErrorCompVisible(false);
          }}
        />
      </Modal>
      <Modal visible={showNoticeAlert} animationType="fade" transparent={true}>
        <NoticeAlertComp
          isLoading={isNoticeLoading}
          message={noticeMessage}
          onClose={() => {
            // setshowNoticeAlert(false)
            handleMoveTableRemainingFundToCredit();
          }}
          onCancel={() => {
            setshowNoticeAlert(false);
          }}
        />
      </Modal>
      <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setIsSuccessCompVisible(false);
          }}
        />
      </Modal>
      <Toast config={toastConfig} />
    </View>
  );
};

const styles = StyleSheet.create({
  myTablesContainer: {
    flex: 1,
    // padding: width * 0.01,
  },
  TableValueContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    padding: 15,
    // marginBottom: 20,
    marginBottom: height * 0.02,
    height: height * 0.4,
    // height: 300,
    borderBottomLeftRadius: 30,
    borderBottomRightRadius: 30,
  },
  label: {
    fontFamily: "Sen-Bold",
    // fontSize: width * 0.035,
    fontSize: dynamicFontSize(14),
    color: Colours.DARKLIGHTGRAY,
  },
  balance: {
    color: Colours.DARKGRAY,
    // fontSize: width * 0.13,
    fontSize: dynamicFontSize(48),
    fontFamily: "Sen-Bold",
    //marginBottom: 5,
  },
  toggleContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  toggleLabel: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
    color: Colours.DARKGRAY,
    marginRight: dynamicSpacing(8),
  },
  sectionTitle: {
    // fontSize: width * 0.04,
    fontSize: dynamicFontSize(16),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Bold",
    marginBottom: height * 0.02,
    marginTop: height * 0.01,
  },
  tableCaption: {
    // fontSize: width * 0.04,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    width: width * 0.6,
    color: Colours.DARKGRAY,
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
  editableTextBox: {
    // fontSize: 16,
    fontSize: dynamicFontSize(16),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
    borderBottomWidth: 1,
    borderColor: Colours.PRIMARY,
  },
  tablesForEdit: {
    display: "flex",
    padding: 20,
    margin: 15,
    marginBottom: 0,
    borderRadius: 10,
    backgroundColor: "white",
  },
  editables: {
    display: "flex",
    marginBottom: 25,
  },
  selectedTable: {
    padding: 10,
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    backgroundColor: Colours.PRIMARY,
    borderRadius: 99,
    paddingHorizontal: 18,
    color: "#FFFFFF",
  },
  unselectedTable: {
    padding: 10,
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    borderRadius: 99,
    paddingHorizontal: 18,
    color: Colours.PRIMARY,
  },
  existingTablesContainer: {
    display: "flex",
    margin: 15,
    marginTop: 0,
    padding: 15,
    borderRadius: 15,
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  invitesTablesContainer: {
    display: "flex",
    margin: 15,
    marginTop: 0,
    padding: 15,
    borderRadius: 15,
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  oneTableContainer: {
    display: "flex",
    backgroundColor: "white",
    borderRadius: 10,
    paddingTop: 10,
    marginBottom: 10,
  },
  tableNameAmountContainer: {
    display: "flex",
  },
  tableAmountContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  moneyText: {
    // fontSize: width * 0.035,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
    color: Colours.DARKGRAY,
  },
  tableProfileViewTxt: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
    color: Colours.PRIMARY,
    textAlign: "center",
  },
  moneyAmount: {
    // fontSize: width * 0.04,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY,
  },
  headerStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 5,
    alignItems: "center",
    gap: 1,
  },
  doingsAmountContainer: {
    display: "flex",
    padding: 10,
    borderRadius: 15,
    backgroundColor: Colours.LIGHTGRAY,
    marginTop: 15,
    marginBottom: 10,
  },
  doingsAmountSubContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  pullCaptionText: {
    // fontSize: width * 0.032,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    color: Colours.DARKGRAY,
  },
  pullAmount: {
    // fontSize: width * 0.04,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY,
  },
  tableCaption_TopUp: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    //gap: 5,
    // backgroundColor: 'green'
  },
  topUpText: {
    width: width * 0.13, // 13% of screen width
    height: width * 0.13,
    borderRadius: width * 0.065,
    borderWidth: 1,
    borderColor: Colours.DARKLIGHTGRAY,
    alignItems: "center",
    justifyContent: "center",
  },
  topUpButtonText: {
    color: Colours.DARKLIGHTGRAY,
    // fontSize: width * 0.03,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
  },
  tableJoined: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: height * 0.015,
  },
  joinedView: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
  },
  joinedText: {
    // fontSize: width * 0.035,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
    color: Colours.MIDGRAY,
  },
  addFriendsButton: {
    backgroundColor: Colours.PRIMARY,
    paddingVertical: height * 0.008,
    paddingHorizontal: width * 0.03,
    borderRadius: 5,
  },
  addFriendsText: {
    color: "white",
    // fontSize: width * 0.035,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
  },
  separator: {
    height: 1,
    backgroundColor: Colours.LIGHTGRAY,
    marginVertical: height * 0.01,
  },
  tableProfileView: {
    display: "flex",
    marginTop: dynamicSpacing(15),
    height: dynamicSize(25),
    justifyContent: "center",
    alignItems: "center",
  },
});

export default BodyMyTables;
